import React from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import { isBrowser } from '@tager/web-core';

import { ButtonLink } from '@/components/Button';
import { shareListItem } from '@/components/Share/constants';

type Props = {
  postTitle: string;
  className?: string;
};

const Share = ({ postTitle, className }: Props) => {
  const t = useTranslations();
  return (
    <Component className={className}>
      <Title>{t('share')}:</Title>
      <List>
        {shareListItem.map((shareItem, index) => (
          <Item key={index}>
            <ShareButton
              href={
                isBrowser()
                  ? `${shareItem.link}${window.location.href}${
                      shareItem.text ? `&text=${postTitle}` : ''
                    }`
                  : ''
              }
              title={`${t('share_in')} ${shareItem.title}`}
              target="_blank"
            >
              {React.createElement(shareItem.itemIcon)}
            </ShareButton>
          </Item>
        ))}
      </List>
    </Component>
  );
};

export default Share;

const Component = styled.div``;

const Title = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
`;
const List = styled.ul`
  margin-top: 3px;
  display: flex;
`;
const Item = styled.li`
  &:not(:first-child) {
    margin-left: 0.625rem;
  }
`;
const ShareButton = styled(ButtonLink)`
  width: 28px;
  height: 28px;

  svg {
    width: 100%;
    height: 100%;
  }
`;
